import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './stars.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';


class StarRating extends Component {

    state = {
        label: this.props.initialValues.label || 'Text input',
        required: this.props.initialValues.isRequired || false,
        starsNumber: [],
        activeNumber: -1,
        requiredError: !!this.props.initialValues.isRequired,
    };

    updateInputPropsInStore = () => {
        const { label, required, starsNumber, activeNumber, requiredError } = this.state;

        const inputProps = {
            type: this.props.initialValues.type,
            label,
            isRequired: required,
            starsCount: starsNumber.length,
            _value: activeNumber + 1,
            _hasValidationErrors: requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);

        let starsNumber = [];
        for (let i = 0; i < (this.props.initialValues.starsCount || 10); i++) {
            starsNumber.push(i);
        }
        this.setState({ starsNumber });
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setNumberOfStars = (e) => {
        let val = e.target.value;
        if (val < 2) {
            val = 2
        }
        let starsNumber = [];
        for (let i = 0; i < val; i++) {
            starsNumber.push(i);
        }
        this.setState({ starsNumber });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    };

    onStarClick = (index) => {
        this.setState({
            activeNumber: index,
            requiredError: false
        });
    };

    render() {
        const { color, textColor, isResultInput } = this.props;
        const { activeNumber, requiredError, required, label } = this.state;
        return (
            <>
                <AppInputWrapper
                    labelFontSize={'18px'}
                    label={label}
                    color={textColor}
                    required={required}
                    requiredError={requiredError}
                >
                    <div
                        className="stars-wrapper"
                        style={{ width: '100%', display: 'flex', flexWrap: 'wrap' }}
                    >
                        {
                            this.state.starsNumber.map((item, index) => (
                                <i
                                    key={index}
                                    onClick={() => this.onStarClick(index)}
                                    className={`fa ${index <= activeNumber ? 'fa-star' : 'fa-star-o'}`}
                                    style={{ color: color }}
                                    aria-hidden="true"
                                />
                            ))
                        }
                    </div>

                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">

                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>

                            <label>
                                <input
                                    value={this.state.starsNumber.length}
                                    onChange={this.setNumberOfStars}
                                    type="number"
                                />
                                number of stars
                            </label>

                            <label>
                                <input
                                    checked={this.state.required}
                                    onChange={this.setRequired}
                                    type="checkbox"
                                />
                                required
                            </label>
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    state => ({}),
    {
        editInputWithProps
    }
)(StarRating);
